import React, {useEffect} from "react";
import {shallowEqual, useSelector} from "react-redux";
import { LoadingDialog } from "../../../partials/controls";

export function CefitLoadingDialog() {
  const { isLoading } = useSelector(
    state => ({ isLoading: state.cefits.listLoading }),
    shallowEqual
  );
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text="Loading ..." />;
}